// import store from '@/store'
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
        path: '/index',
        name: 'index',
        component: HomeView
    },
    // {
    //     path: '/:pathMatch(.*)*',
    //     name: 'page-not-found',
    //     component: PageNotFound
    // }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
})

export default router
